import React, { createContext, useState } from 'react';
import { getUnidad, getPermissions } from '../utils/Common';

export const Context = createContext();

const Provider = ({ children }) => {
  const [userId, setUserId] = useState('tokenid');
  const [nameId, setNameId] = useState('');
  const [title, setTitle] = useState('');
  const [boss, setBoss] = useState('')

  const unidad = getUnidad();
  const permisos = getPermissions();
  const value = {
    unidad,
    permisos,
    userId,
    title,
    nameId,
    boss,
    setUserId: (user) => {
      setUserId(user);
    },
    setTitle: (tit) => {
      setTitle(tit);
    },
    setNameId: (name) => {
      setNameId(name);
    },
    setBoss: (name) => {
      setBoss(name)
    }
  };

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
export default {
  Provider,
  Consumer: Context.Consumer,
};
